import {
  eachOwn,
  fmt
} from '@packages/utils'
import {
  imageView
} from '@packages/utils'

export default {
  options: {
    date: true,
    currency: true,
    value: true,
    url: true
  },
  install(Vue, options = {}) {
    let opts = Object.assign({}, this.options, options)

    eachOwn(opts, (value, key) => {
      if (value !== false && fmt[key]) {
        Vue.filter(key, fmt[key])
      }
    })

    Vue.filter('imageView', imageView)
  }
}



// WEBPACK FOOTER //
// ./src/packages/filters/index.js